<template>
  <svg
    :width="size"
    :height="size"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    viewBox="0 0 24 24"
  >
    <line
      x1="18"
      y1="6"
      x2="6"
      y2="18"
    />
    <line
      x1="6"
      y1="6"
      x2="18"
      y2="18"
    />
  </svg>
</template>

<script>
export default {
  name: "CloseIcon",
  props: {
    size: { type: Number, default: 12 },
  },
};
</script>
